import { jsx } from "react/jsx-runtime";
import useThemePresetClasses from "../../../hooks/useThemePresetClasses.js";
import { cn } from "../../../utils/cn.js";
const ButtonIcon = ({
  classes,
  className,
  children,
  variant = "contained",
  size = "md",
  icon,
  loading = false,
  ...btnProps
}) => {
  const { themeClasses } = useThemePresetClasses("ButtonIcon", classes, className, {
    variant,
    modifier: size
  });
  return /* @__PURE__ */ jsx(
    "button",
    {
      className: cn(themeClasses == null ? void 0 : themeClasses.root),
      ...btnProps,
      disabled: loading || btnProps.disabled,
      children: /* @__PURE__ */ jsx("span", { className: cn(themeClasses == null ? void 0 : themeClasses.icon), children: icon })
    }
  );
};
const ButtonIcon$1 = ButtonIcon;
export {
  ButtonIcon$1 as default
};
